module.exports = __webpack_public_path__ + "static/media/comparison-example.85ba7590.png";